import axios from 'axios';
import { getCurrentSession } from '@pages/auth/helpers';
import TrackingService from '@services/TrackingService';

// this automatically adds access token and device code to all requests going to our backend:
axios.interceptors.request.use(async (config) => {
  if (config.url.startsWith(process.env.REACT_APP_API_ENDPOINT)) {
    const session = await getCurrentSession();
    if (session) {
      const token = session.accessToken.jwtToken;
      Object.assign(config.headers, { accesstoken: token });
    }
    const deviceCode = TrackingService.getDeviceCode();
    const deviceCodeBy = TrackingService.getServiceName();
    if (deviceCode) {
      Object.assign(config.headers, { 'device-code': deviceCode, 'device-code-by': deviceCodeBy });
    }
  }
  return config;
}, error => Promise.reject(error));
